import { AbstractControl } from '@angular/forms';

export function PricesValidator(control: AbstractControl): { [key: string]: boolean } | null {
  return control && control.value ? null : { required: true };
}
